<template>
  <component
      ref="component"
      :is="isButtonType"
      size="small"
      :disabled="disabled"
      :type="type"
      :icon="iconFormat"
      :loading="btnLoading"
      @click="btnClick"
      v-bind="$attrs"
      :render="render"
  >
    <template v-if="title">{{$lang(title)}}</template>
    <slot></slot>
  </component>
</template>

<script>
const iconType = {
  // 导出
  export: 'iconfont icondaochu1',
  // 下载中心
  downloadCore: 'iconfont iconanniu-xiazaizhongxin',
  // 发送,推送
  send: 'iconfont iconbiaodan-fabu',
  // 锁帐
  lock: 'iconfont iconsuozhang1',
  // 解锁
  unLock: 'iconfont iconjiesuo1',
  // 审核
  audit: 'iconfont iconanniu-shenhe',
  // 反审核
  unAudit: 'iconfont iconjiesuo1',
  // 修改
  edit: 'iconfont iconpiliangxiugai',
  // 复制
  copy: 'iconfont iconfuzhi',
  // 确认账单
  confirm: 'iconfont iconquerenzhangdan',
  // 重新算费
  resetFee: 'iconfont iconzhongsuanfeiyong',
  // 取消
  cancel: 'iconfont iconyunli-chexiaotiaodu',
  // 打印
  print: 'iconfont iconanniu-dayin'
}

export default {
  name: 'FinButton',
  data() {
    return {
      btnLoading: false
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: undefined
    },
    buttonType: {
      type: String,
      default: 'el-button'
    },
    type: {
      type: String,
      default: 'info'
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconType: {
      type: String,
      default: ''
    },
    clickOnLoading: {
      type: Function,
      default: undefined
    },
    click: {
      type: Function,
      default: undefined
    },
    render: {
      type: Function,
      default: undefined
    }
  },
  watch: {
    loading(val) {
      this.btnLoading = val
    }
  },
  computed: {
    isButtonType() {
      return this.buttonType
    },
    iconFormat() {
      if (iconType[this.iconType]) {
        return iconType[this.iconType]
      }
      if (this.icon) {
        return 'iconfont ' + this.icon
      }
      return ''
    }
  },
  methods: {
    closeLoading() {
      this.btnLoading = false
    },
    btnClick(e) {
      if (!this.disabled) {
        if (this.clickOnLoading) {
          this.btnLoading = true
          this.clickOnLoading(this.closeLoading, e)
        }
        if (this.click) {
          this.click(e)
        }
        this.$emit('click', e)
      }
      let target = e.target
      if (target?.nodeName === 'SPAN') {
        target = e.target.parentNode
      }
      target?.blur()
    }
  }
}
</script>
